import { setInputMask } from '../../../components/views/chat/actions';

const ShowAddressForm = {
    name: 'showAddressForm',
    exec: (customMessage) => {
        customMessage.contentType = 'AddressForm';
        customMessage.message = 'Formularz adresowy';
        setInputMask('disableInput');
    }
};

export default ShowAddressForm;
